import { render, staticRenderFns } from "./gallery-modal-component.vue?vue&type=template&id=8b52b134&scoped=true&"
import script from "./gallery-modal-component.vue?vue&type=script&lang=ts&"
export * from "./gallery-modal-component.vue?vue&type=script&lang=ts&"
import style0 from "./gallery-modal-component.vue?vue&type=style&index=0&id=8b52b134&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b52b134",
  null
  
)

export default component.exports